/* import __COLOCATED_TEMPLATE__ from './ilios-calendar-month.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import Component from '@glimmer/component';
import { DateTime } from 'luxon';
import { action } from '@ember/object';
let IliosCalendarMonthComponent = (_class = class IliosCalendarMonthComponent extends Component {
  get ilmPreWorkEvents() {
    const preWork = this.args.calendarEvents.reduce((arr, ev) => {
      if (!ev.isBlanked && ev.isPublished && !ev.isScheduled) {
        arr = [...arr, ...ev.prerequisites];
      }
      return arr;
    }, []);
    return preWork.filter(ev => ev.ilmSession).filter(ev => {
      return !ev.isBlanked && ev.isPublished && !ev.isScheduled;
    });
  }
  get nonIlmPreWorkEvents() {
    return this.args.calendarEvents.filter(ev => {
      return ev.postrequisites.length === 0 || !ev.ilmSession;
    });
  }
  get singleDayEvents() {
    return this.nonIlmPreWorkEvents.filter(event => DateTime.fromISO(event.startDate).hasSame(DateTime.fromISO(event.endDate), 'day'));
  }
  get multiDayEventsList() {
    return this.nonIlmPreWorkEvents.filter(event => !DateTime.fromISO(event.startDate).hasSame(DateTime.fromISO(event.endDate), 'day'));
  }
  changeToDayView(date) {
    if (this.args.areDaysSelectable && this.args.changeDate && this.args.changeView) {
      this.args.changeDate(date);
      this.args.changeView('day');
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "changeToDayView", [action], Object.getOwnPropertyDescriptor(_class.prototype, "changeToDayView"), _class.prototype), _class);
export { IliosCalendarMonthComponent as default };